import { BaseListFilter } from '../../../models/base-list-filter.model';

export class IntegrationsFilter extends BaseListFilter {}
